module.exports = __webpack_public_path__ + "images/emoji/grey_exclamation.879a82e7793cf4237739.png";